import en from './json/en'
import hk from './json/hk'
import vi from './json/vi'
import th from './json/th'
import id from './json/id'
// 台灣和香港用同一個語言json
const tw = hk
const sg = en
const my = en
const ph = en
const IN = en // in是关键字
export const defaultLang = 'en'
export const supportedLangs = [/*'en', */'vi', 'hk', 'tw', 'th', 'id', 'sg', 'my', 'ph'/*, 'in'*/]
export const langMap = {
  en: 'English',
  vi: 'Vietnam',
  hk: 'Hongkong',
  tw: 'Taiwan',
  th: 'Thailand',
  id: 'Indonesia',
  sg: 'Singapore',
  my: 'Malaysia',
  ph: 'Philippines',
  in: 'India'
}
export const i18nMessages = {
  en,
  vi,
  hk,
  tw,
  th,
  id,
  sg,
  my,
  ph,
  in: IN
}

export const aihelpLangOptions = [
  {
    appLang: 'en',
    aihelpLang: 'en'
  },
  {
    appLang: 'vi',
    aihelpLang: 'vi'
  },
  {
    appLang: 'hk',
    aihelpLang: 'zh-TW'
  },
  {
    appLang: 'tw',
    aihelpLang: 'zh-TW'
  },
  {
    appLang: 'th',
    aihelpLang: 'th'
  },
  {
    appLang: 'id',
    aihelpLang: 'id'
  },
  {
    appLang: 'sg',
    aihelpLang: 'en'
  },
  {
    appLang: 'my',
    aihelpLang: 'en'
  },
  {
    appLang: 'ph',
    aihelpLang: 'en'
  },
  {
    appLang: 'in',
    aihelpLang: 'en'
  }
]
